import * as type from "../action-types";

type load = { id: string }

export const getProjectStatusAction = (payload?: load) => ({
    type: type.GET_PROJECT_STATUS
});
